import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=16874e7a&scoped=true"
import script from "./CustomFields.vue?vue&type=script&lang=js"
export * from "./CustomFields.vue?vue&type=script&lang=js"
import style0 from "./CustomFields.vue?vue&type=style&index=0&id=16874e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16874e7a",
  null
  
)

export default component.exports